import { UsersRound } from 'lucide-react'

import styles from '../PatientsPage.module.css'

export function PatientEmptyState() {
  return (
    <div className={styles.emptyState}>
      <span className={styles.emptyIcon} aria-hidden="true">
        <UsersRound size={22} />
      </span>
      <h2>No practice patients yet</h2>
      <p>No active NexHealth patient records are available for this clinic.</p>
    </div>
  )
}
